module.exports = __webpack_public_path__ + "static/media/icon-piece1-2.9bc9b99a.png";